/**
 * Adds multiple items to the cart
 * @param {Array} cartItems - Array of objects with variantId and qty
 * @returns {Promise} - Promise that resolves when items are added to cart
 */
async function addMultipleItemsToCart(cartItems) {
  // Format items for Shopify Cart API
  const items = cartItems.map(item => ({
    id: item.id,
    quantity: item.qty
  }));

  // Prepare sections to bundle for cart updates
  let sectionsToBundle = [];
  document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { 
    bubbles: true, 
    detail: { sections: sectionsToBundle } 
  }));

  // Prepare request body
  const body = JSON.stringify({
    items,
    sections: sectionsToBundle,
    sections_url: window.location.pathname
  });

  try {
    // Add items to cart
    const response = await fetch(window.theme.routes.cart_add_url, {
      ...window.theme.utils.fetchConfig('javascript'),
      body
    });

    const parsedState = await response.json();

    // Handle errors
    if (parsedState.status) {
      throw new Error(parsedState.description || 'Failed to add items to cart');
    }

    // Get updated cart data
    const cartJson = await (await fetch(window.theme.routes.cart_url, { 
      ...window.theme.utils.fetchConfig('json', 'GET')
    })).json();
    
    cartJson['sections'] = parsedState['sections'];

    // Publish cart update event
    window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { 
      source: 'cart-utils', 
      cart: cartJson 
    });

    // Dispatch custom event for product added
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product: parsedState
      }
    }));

    // Show cart drawer
    // const cartDrawer = document.querySelector('cart-drawer');
    // if (cartDrawer) {
    //   cartDrawer.show();
    // }

    return cartJson;
  } catch (error) {
    console.error('Error adding items to cart:', error);
    throw error;
  }
}

// Export the function
window.addMultipleItemsToCart = addMultipleItemsToCart; 